import React from 'react';

const StockAccountingWarning = () => (
  <div role="status" className="rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-700 dark:bg-amber-900/20 dark:text-amber-200">
    Historical FX is missing for some stock transactions. Cost basis and P&amp;L are unavailable until their FX snapshots are repaired. Your transactions are kept and can still be edited. Chart markers without historical FX are omitted.
  </div>
);

export default StockAccountingWarning;
